

































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { BListGroupItem, BBadge } from "bootstrap-vue";
import { TimelineItem } from "@/models/timeline.model";
import AppDateDisplay from "../AppDateDisplay.vue";
import AppBallsDisplay from "../ScorersTable/AppBallsDisplay.vue";

@Component({
  name: "AppTimelineItem",
  components: { BListGroupItem, AppDateDisplay, BBadge, AppBallsDisplay }
})
export default class AppTimelineItem extends Vue {
  @Prop({ required: true }) timelineItem: TimelineItem;
}
